import React from "react";
import {
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  Label,
  PanelType,
  PrimaryButton,
  SearchBox,
  SelectionMode,
  Stack,
  Text,
  TooltipHost,
} from "@fluentui/react";
import { mdiTrashCanOutline } from "@mdi/js";
import {
  assignCemCustomers,
  deleteCemCustomers,
  getCemCustomers,
} from "../../services/datacenter/DataCenterManagerService";
import { THEME } from "../../utils/Styles";
import {
  IAssignCemCustomer,
  ICemCustomer,
  ICustomers,
  ICustomerVM,
} from "../../vm";
import { childrenGap } from "../common/Constants";
import CustomDrawer from "../common/CustomDrawer";
import NoDataTile from "../common/NoDataTile";
import { ToastContext } from "../common/ToastProvider";
import Icon from "@mdi/react";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import { getAllCustomers } from "../../services/customers/CustomerService";
import { Loading } from "../../services/Loading";
import TotalNumbers from "../common/TotalNumbers";

export interface ManageAccDialogProps {
  cemId: string;
  handleDialogClose: any;
}

const ManageAccDialog: React.FC<ManageAccDialogProps> = ({
  cemId,
  handleDialogClose,
}) => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  // state
  const [state, setState] = React.useState({
    cemCustomers: [],
    isLoading: false,
    manageAssignDialog: {
      isOpen: false,
    },
    selectedCustomerIds: [],
    tempCustomerList: [],
    selectedCustomers: [],
  } as {
    cemCustomers: ICemCustomer[];
    isLoading: boolean;
    manageAssignDialog: {
      isOpen: boolean;
    };
    selectedCustomerIds: string[];
    tempCustomerList: ICustomers[];
    selectedCustomers: IAssignCemCustomer[];
  });
  const [searchObj, setSearchObj] = React.useState({
    search: "",
  } as { search?: string });

  const [customerSearchData, setCustomerSearchData] = React.useState<
    ICustomerVM[]
  >([]);
  const [customerAssignedData, setCustomerAssignedData] = React.useState<
    ICustomerVM[]
  >([]);

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllCemCustomer();
    };
    asyncFunc();
  }, []);

  const getAllCemCustomer = async (search?: any) => {
    if (!search) setState({ ...state, isLoading: true });
    let updatedSearch = { ...searchObj };
    if (search) {
      updatedSearch = { ...updatedSearch, ...search };
    }
    let result = await getCemCustomers({ userId: cemId, ...updatedSearch });
    if (result?.success) {
      if (search) setSearchObj(updatedSearch);
      setState({ ...state, cemCustomers: result.data, isLoading: false });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting cem-customers",
        "error"
      );
    }
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal>
            <TooltipHost
              content="Unassign"
              id={`deleteCc`}
              calloutProps={{ gapSpace: 0 }}
              styles={{ root: { display: "inline-block" } }}
            >
              <span onClick={() => onUnAssign(item, index)}>
                <Icon
                  path={mdiTrashCanOutline}
                  size={0.8}
                  className="pointer"
                  color={THEME.palette.themePrimary}
                />
              </span>
            </TooltipHost>
          </Stack>
        );
      case "customerName":
        return <Text style={{ fontWeight: 600 }}>{item.customerName}</Text>;
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const onUnAssign = async (item: ICemCustomer, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete this customer",
      async () => {
        setState({
          ...state,
          isLoading: true,
        });
        let result = await deleteCemCustomers(item);
        if (result.success) {
          showToast("Customer deleted successfully", "success");
          let cemCustomers = [...state.cemCustomers];
          cemCustomers.splice(index, 1);
          setState({
            ...state,
            cemCustomers,
            isLoading: false,
          });
        } else {
          setState({
            ...state,
            isLoading: false,
          });
          showToast(result.message || "Error while deleting customer", "error");
        }
      }
    );
  };

  const handleAssignDialog = (isOpen: boolean) => {
    setState({ ...state, manageAssignDialog: { isOpen } });
  };

  // const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
  //   noResultsFoundText: "No Customer found",
  // };

  // const onFilterChanged = async (
  //   filterText: string,
  //   tagList?: IPersonaProps[]
  // ): Promise<IPersonaProps[]> => {
  //   if (filterText && filterText.length >= 2) {
  //     let result = await getAllCustomers({
  //       search: filterText,
  //       offset: 0,
  //       limit: 12,
  //     });
  //     if (result?.success) {
  //       let customerTag: IPersonaProps[] = [];
  //       let tempCustomerList = [...state.tempCustomerList];
  //       result?.data.forEach((item) => {
  //         tempCustomerList.push(item);

  //         customerTag.push({
  //           text: item.name,
  //           secondaryText: String(item.regSapNo),
  //           id: item._id,
  //         });
  //       });
  //       console.log("tagList", tagList);
  //       console.log("cemc", state.cemCustomers);

  //       // tagList?.forEach((tag) => {
  //       //   customerTag = customerTag.filter((e) => e.id !== tag.id);
  //       // });
  //       state.cemCustomers?.forEach((i) => {
  //         customerTag = customerTag.filter((e) => e.id !== i.customerId);
  //       });

  //       setState({ ...state, tempCustomerList });
  //       return customerTag;
  //     } else {
  //       return [];
  //     }
  //   }
  //   return [];
  // };

  const OnAssign = async (data: IAssignCemCustomer[]) => {
    if (data.length <= 0) {
      showToast("Please select a customer", "error");
    } else {
      setState({ ...state, isLoading: true });
      let result = await assignCemCustomers(data);
      if (result?.success) {
        let cemCustomers = [...state.cemCustomers];

        data.map((ele) => {
          let index = customerAssignedData.findIndex(
            (c) => c._id === ele.customerId
          );
          if (index !== undefined) {
            cemCustomers.push({
              //   _id: state.tempCustomerList[index]._id,
              customerName: customerAssignedData[index].name,
              sapCode: customerAssignedData[index].regSapNo,
              customerId: customerAssignedData[index]._id as string,
              userId: cemId,
            });
            // let index = state.tempCustomerList.findIndex(
            //   (c) => c._id === ele.customerId
            // );
            // cemCustomers.push({
            //   //   _id: state.tempCustomerList[index]._id,
            //   customerName: state.tempCustomerList[index].name,
            //   sapCode: state.tempCustomerList[index].regSapNo,
            //   customerId: state.tempCustomerList[index]._id as string,
            //   userId: cemId,
            // });
          }
        });

        setState({
          ...state,
          selectedCustomerIds: [],
          selectedCustomers: [],
          cemCustomers,
          manageAssignDialog: { isOpen: false },
          isLoading: false,
        });
        showToast("Customer/Customers assign successfully", "success");
      } else {
        showToast(result.message || "Can't assign customer/customers", "error");
        setState({ ...state, isLoading: false });
      }
    }
  };

  const _searchCustomers = async (search?: string) => {
    if (!search || search.length < 3) return;
    let searchObj = {
      search: search,
      offset: 0,
      limit: 10,
      showCircuitIdAndDc: true,
    };
    let customers: any = await getAllCustomers(searchObj);
    if (customers?.success) {
      const tempData: Array<ICustomerVM> = customers.data;
      setCustomerSearchData(getDetailListData(tempData));
    }
  };
  const getDetailListData = (data: ICustomerVM[]) => {
    const dataArr = data.map((d) => {
      // d.name = d.name + ' (' + d.regSapNo + ')';
      if (d.location)
        d["customerLocation"] = d.location.map(
          (l) =>
            l.datacenter.name + (l.circuitId ? " (" + l.circuitId + ")" : "")
        );
      // .join(", ");
      return d;
    });
    return dataArr;
  };
  const tempSelectedCustomer = customerAssignedData.map((d) => d._id);
  const tempCustomerSearchList = customerSearchData.filter(
    (d) => !tempSelectedCustomer.includes(d._id)
  );
  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <CustomDrawer
        title={"View Assigned CEM Customers"}
        handelOpen={true}
        drawerType={PanelType.large}
        onClose={() => handleDialogClose(false)}
      >
        <Stack tokens={childrenGap}>
          <Stack.Item>
            <Stack
              horizontal
              horizontalAlign="space-between"
              verticalAlign="center"
            >
              <Stack.Item>
                <Stack
                  horizontal
                  verticalAlign="center"
                  wrap
                  tokens={childrenGap}
                >
                  <Stack.Item>
                    <SearchBox
                      value={searchObj.search}
                      styles={{ root: { width: "300px" } }}
                      placeholder="Search by customer name / sap code"
                      onChange={(e, value) =>
                        getAllCemCustomer({ ...searchObj, search: value })
                      }
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <TotalNumbers value={state.cemCustomers.length} />
                  </Stack.Item>
                </Stack>
              </Stack.Item>
              <Stack.Item align="end">
                <PrimaryButton
                  text="Assign Customer"
                  onClick={() => handleAssignDialog(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            {state.cemCustomers && state.cemCustomers.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.cemCustomers}
                  columns={[
                    {
                      key: "customerName",
                      name: "Customer Name",
                      fieldName: "customerName",
                      minWidth: 220,
                      maxWidth: 270,
                      isResizable: true,
                    },
                    {
                      key: "sapCode",
                      name: "Sap Code",
                      fieldName: "sapCode",
                      minWidth: 100,
                      maxWidth: 150,
                      isResizable: true,
                    },
                    {
                      key: "actions",
                      name: "Actions",
                      fieldName: "actions",
                      minWidth: 80,
                      maxWidth: 100,
                      isResizable: true,
                    },
                  ]}
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Cem Customers Found"></NoDataTile>
            )}
          </Stack.Item>
          <Stack.Item align="end">
            <DefaultButton
              text="Cancel"
              onClick={() => handleDialogClose(false)}
              className="borderless-btn"
            />
          </Stack.Item>
        </Stack>
        {state.manageAssignDialog.isOpen && (
          <CustomDrawer
            title="Assign Customer"
            handelOpen={true}
            drawerType={PanelType.large}
            onClose={() => handleAssignDialog(false)}
          >
            <Stack tokens={childrenGap}>
              <Stack.Item>
                {/* <NormalPeoplePicker
                  inputProps={{
                    placeholder: "Search customers by name/sap code...",
                  }}
                  //   itemLimit={1}
                  onResolveSuggestions={onFilterChanged}
                  removeButtonAriaLabel="Remove"
                  pickerSuggestionsProps={pickerSuggestionsProps}
                  onChange={(items: any) => {
                    let selectedItems: any = [];
                    let selectedCustomers: IAssignCemCustomer[] = [];
                    // let selectedCustomerId = "";
                    items.forEach((element: any) => {
                      selectedItems.push(element.id);
                      selectedCustomers.push({
                        userId: cemId,
                        customerId: element.id,
                      });
                      //   selectedCustomerId = element.id;
                    });
                    setState({
                      ...state,
                      selectedCustomerIds: selectedItems,
                      selectedCustomers,
                    });
                    // console.log(selectedItems);
                  }}
                /> */}
                <SearchBox
                  // styles={{ root: { width: '300px' } }}
                  placeholder="Customer Name/SAP Code"
                  onChange={(e, value) => _searchCustomers(value)}
                />
              </Stack.Item>
              {tempCustomerSearchList.length > 0 && (
                <Stack.Item>
                  <Label style={{ color: "#135c8a" }}>Searched results</Label>
                  <div className="office-table bg-white">
                    <table className="ms-Table bordered-table w-100">
                      <thead className="html-table-thead">
                        <tr>
                          <th>Name</th>
                          <th>Sap Code</th>
                          <th>Location</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tempCustomerSearchList.map((d, index) => {
                          return (
                            <tr key={index}>
                              <td>{d.name}</td>
                              <td>{d.regSapNo}</td>
                              <td>
                                {d.customerLocation &&
                                  d.customerLocation.length > 0 &&
                                  d.customerLocation.map((c) => c).join(", ")}
                              </td>
                              <td className="text-center">
                                <DefaultButton
                                  text="Select"
                                  onClick={() => {
                                    const temp = [...customerAssignedData];
                                    temp.push(d);
                                    setCustomerAssignedData([...temp]);
                                  }}
                                  className="borderless-btn"
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Stack.Item>
              )}
              {customerAssignedData.length > 0 && (
                <Stack.Item>
                  <Label style={{ color: "#135c8a" }}>
                    List of Assigned Customers
                  </Label>
                  <div className="office-table bg-white">
                    <table className="ms-Table bordered-table w-100">
                      <thead className="html-table-thead">
                        <tr>
                          <th>Name</th>
                          <th>Sap Code</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerAssignedData.map((d, index) => {
                          return (
                            <tr key={index}>
                              <td>{d.name}</td>
                              <td>{d.regSapNo}</td>
                              <td>{d.customerLocation}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Stack.Item>
              )}

              <Stack.Item>
                <Stack
                  horizontal
                  wrap
                  tokens={childrenGap}
                  horizontalAlign="end"
                  className="pt-16"
                >
                  <DefaultButton
                    text="Cancel"
                    onClick={() => handleAssignDialog(false)}
                    className="borderless-btn"
                  />
                  <PrimaryButton
                    text="Submit"
                    onClick={() =>
                      OnAssign(
                        customerAssignedData.map((d) => {
                          return { customerId: d._id as string, userId: cemId };
                        })
                      )
                    }
                    // onClick={() => OnAssign(state.selectedCustomers)}
                  />
                </Stack>
              </Stack.Item>
            </Stack>
          </CustomDrawer>
        )}
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageAccDialog;
